define('mmd.common.pop_login',function(require, exports, module){
    var $ = require('zepto');
    var login = require('mmd.common.no_ui_login_register').init();
    var loadCss=require('load.css');
    var rnd = new Date().getTime().toString();
    var cover_id = 'common_login_cover_'+rnd;
    var phoneid = 'common_login_phone_'+rnd;
    var getcodeid = 'common_login_get_code_'+rnd;
    var codeid = 'common_login_code_'+rnd;
    var submitbtnid = 'common_login_btn_'+rnd;
    var imglayerid = 'common_login_img_layer_'+rnd;
    var imgid = 'common_login_img_'+rnd;
    var imgcodeid = 'common_login_img_input_'+rnd;
    var imgcodebtnid = 'common_login_img_btn_'+rnd;

    function start_login(success_cb,fail_cb){
        var params = {
            beforerequest: function () {
                $('#'+cover_id).show();
                $('#'+codeid+',#'+imgcodeid).val('');
                window.pop_login_need_reg = true;
            },
            phoneid: phoneid,
            getcodeid: getcodeid,
            codeid: codeid,
            submitbtnid: submitbtnid,
            imglayerid:imglayerid,
            imgid:imgid,
            imgcodeid:imgcodeid,
            imgcodebtnid:imgcodebtnid,
            success: function () {
                $('#'+cover_id+',#'+imglayerid).hide();
                $('#'+imgid).attr('src','');

                if(typeof(success_cb) == "function"){
                    var re_login = typeof window.pop_login_need_reg != 'undefined';
                    success_cb(re_login);
                }
            },
            fail:function(){
                $('#'+cover_id+',#'+imglayerid).hide();
                $('#'+imgid).attr('src','');

                if(typeof(fail_cb) == "function"){
                    var re_login = typeof window.pop_login_need_reg != 'undefined';
                    fail_cb(re_login);
                }
            }
        };
        //console.log(params);
        login.start(params);
    }

    function init_fn(){
        if($('#'+cover_id).length >0){
            return;
        }

        var str_template=`<div class="common_login_cover" id="common_login_cover_${rnd}">
           <div class="common_login_cover_inner">
              <div class="js-close-layer close-layer">
                  <div class="js-close-layer-inner close-layer-inner"></div>
               </div>
                <div class="common_login_img_layer" id="common_login_img_layer_${rnd}" >
                    <div class="common_login_row">
                        <img id="common_login_img_${rnd}" src="//img.mdcdn.cn/h5/img/placeholder_10040.png" alt="">
                    </div>
                    <div class="common_login_row">
                        <input class="common_login_img_input" id="common_login_img_input_${rnd}" type="text" placeholder="图片验证码" >
                        <div class="common_login_img_btn" id="common_login_img_btn_${rnd}" >确 定</div>
                    </div>
                </div>
                <div class="common_login_row">
                    <input class="common_login_phone" id="common_login_phone_${rnd}" type="text" placeholder="请输入手机号" >
                </div>
                <div class="common_login_row">
                    <input class="common_login_code" id="common_login_code_${rnd}" type="text" placeholder="请输入验证码" >
                    <div class="common_login_get_code" id="common_login_get_code_${rnd}">获取验证码</div>
                </div>
                <div class="common_login_btn_out">
                    <div class="common_login_btn" id="common_login_btn_${rnd}">确 定</div>
                </div>
            </div>
        </div>`;

        $('body').append(str_template);
        $('#'+cover_id+' .js-close-layer').click(function () {
            $('#'+cover_id).hide();
        })

    }


    exports.init = function(){
        loadCss.loadCss('https://g.mdcdn.cn/h5/css/act/internal/common_login.css?t=201605123');
        init_fn();
        return {
            start:start_login
        };
    }
});


// WEBPACK FOOTER //
// ./../common/js/mmd.common.pop_login.js